import { blankKeyText } from '_legacy/constants/gridText';
import {
    FetchMappingGridTankTypeDisplayValue,
    FetchMappingSelectTankTypeDisplayValue,
} from '../../../data/mappings';

export const TankTypeFormatter = (params) => {
    const { value, node } = params;
    if (!value) {
        return '';
    }

    if (!node) {
        return FetchMappingGridTankTypeDisplayValue(value);
    }

    return FetchMappingGridTankTypeDisplayValue(value);
};

export const TankTypeFilterFormatter = (params) => {
    const { value } = params;
    if (!value) {
        return blankKeyText;
    }

    return FetchMappingGridTankTypeDisplayValue(value);
};
